import * as React from 'react';
import styled from 'styled-components';
import { ISuggestion } from './types';
import t from './locales';

const TitleView = styled.h1`
  font-size: 0.875em;
  font-weight: normal;
  margin: 0;
`;

interface IProps {
  q: ISuggestion;
  count: number;
}

const YadoListTitle: React.FC<IProps> = (props) => {
  const { q, count } = props;
  if (q == null) { return (<TitleView>{t.yadoListTitle()}</TitleView>); }
  return (
    <TitleView>
      {t.yadoListTitleFor({ subject: q.label, count })}
    </TitleView>
  )
};

export default YadoListTitle;
